import router from '../router'
import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'


Vue.use(Vuex)

/*
    Tiempo maximo de espera del envio de la opcion de nivel (3 minutos).
    En Nivel 1 el POST sube el recibo y el certificado en un unico multipart
    (hasta 5 MB cada uno): con una conexion movil lenta puede tardar mucho en
    subir. Sin un timeout explicito axios espera
    indefinidamente y la falla no se distingue de un error del servidor.
 */
const TIMEOUT_ENVIO_OPCION_NIVEL = 180000

/*
    Traduce un error de axios al mensaje que ve la afiliada.
    El motivo del fallo cambia la accion que puede tomar: no es lo mismo un
    adjunto demasiado pesado que un error del servidor.
 */
function mensajeErrorEnvioOpcionNivel(error) {
    if (error.code === 'ECONNABORTED') {
        return 'El envío tardó demasiado y se interrumpió, probablemente por una conexión lenta. Probá desde una red Wi-Fi o con archivos más livianos e intentá nuevamente.'
    }

    if (!error.response) {
        return 'No pudimos comunicarnos con el servidor. Revisá tu conexión a internet e intentá nuevamente.'
    }

    if (error.response.status === 413) {
        return 'El archivo adjunto supera el tamaño permitido. Volvé a generar el PDF con menor resolución (o adjuntá una foto) e intentá nuevamente.'
    }

    return 'Error al intentar realizar la opción de nivel.'
}

export default ({
    namespaced: true,

    state: {

        extemporaneo: null,

        dialogoOpcionNivelVisible: false,

        opcionNivelAfiliado: {
            nroafi: '',
            nivelActual: '',
            tienePlanJoven: '',
            anioOpcionNivel: '',
            empleo: '',
            empleoTipo: '',
            empleoDesde: '',
            puedeTramitarNivel: '',
            nivelPedido: null,
            estadoNivelPedido: null,
            emailNivelPedido: null,
            puedeDesestimar: '',
            desetimacionPendiente: '',
            extemporaneo: null

        },
        datosNivelAfiliado: {
            nroafi: '',
            nuevoNivel: '',
            esJubilado: '',
            repiteEmpleo: '',
            nuevoNivelEmail: '',
            empleo: '',
            empleoTipo: ' ',
            empleoDesde: '',
            mail: ''
        },
    },

    getters: {
        opcionNivelAfiliado(state) {
            return state.opcionNivelAfiliado
        },
        datosNivelAfiliado(state) {
            return state.datosNivelAfiliado
        },
        extemporaneo(state) {
            return state.extemporaneo
        },
        dialogoOpcionNivelVisible(state) {
            return state.dialogoOpcionNivelVisible
        },
        opcionNivelHabilitado() {
            return process.env.VUE_APP_OPCION_NIVEL === 'true'
        },
        // Regla unica para mostrar el dialogo de opcion de nivel: feature encendido,
        // tramite no aprobado, afiliado activo y con nivel validado.
        cumpleCondicionesOpcionNivel(state, getters, rootState) {
            const user = rootState.auth?.user || {}
            return getters.opcionNivelHabilitado
                && state.opcionNivelAfiliado?.estadoNivelPedido !== 'A'
                && !!user.esactivo
                && user.nivel_validez == 'A'
        }
    },
    mutations: {
        setOpcionNivelAfiliado(state, payload) {
            state.opcionNivelAfiliado = payload
            state.extemporaneo = payload.extemporaneo

        },
        setDatosNivelAfiliado(state, payload) {
            state.datosNivelAfiliado.nroafi = payload.nroafi
            state.datosNivelAfiliado.nuevoNivel = payload.nuevoNivel
            state.datosNivelAfiliado.esJubilado = payload.esJubilado
            state.datosNivelAfiliado.repiteEmpleo = payload.repiteEmpleo
            state.datosNivelAfiliado.empleo = payload.empleo
            state.datosNivelAfiliado.empleoTipo = payload.empleoTipo
            state.datosNivelAfiliado.empleoDesde = payload.empleoDesde
            state.datosNivelAfiliado.mail = payload.mail
        },
        setExtemporaneo(state, payload) {
            state.extemporaneo = payload
        },
        setDialogoOpcionNivelVisible(state, payload) {
            state.dialogoOpcionNivelVisible = payload
        }


    },
    actions: {
        // Si el afiliado no cumple las condiciones, el click solo navega y no abre nada.
        abrirDialogoOpcionNivel({ commit, getters }) {
            if (!getters.cumpleCondicionesOpcionNivel) return
            commit('setDialogoOpcionNivelVisible', true)
        },
        cerrarDialogoOpcionNivel({ commit }) {
            commit('setDialogoOpcionNivelVisible', false)
        },
        //getNivelAfiliado: dado un afiliado devuelve informacion
        // de opcion de nivel elegida anteriormente 
        //estadoNivelPedido": "P", pendiente
        //estadoNivelPedido": "X", sin estado o no definido
        //estadoNivelPedido": "A", aprobado
        //estadoNivelPedido": "R", rechazado


        async getNivelAfiliado({ commit, dispatch }) {
            await axios({
                method: 'post',
                url: process.env.VUE_APP_API + 'portal/opcionNivel',
                withCredentials: false,
                data: { nroafi: sessionStorage.getItem('nroafi') },
                headers: {
                    "Content-Type": "application/json",
                },
            }).then(function (response) {
                const res = response.data.opcionNivel[0]
                commit('setOpcionNivelAfiliado', res)
            }).catch(function (error) {
                console.log(error.response.data.message);
                dispatch('notificaciones/showSnack', {
                    message: error.response.data.message,
                    type: (error.response.status).toString(),
                }, { root: true })
            }).finally(() => {
                dispatch('notificaciones/stopLoading', null, { root: true })
                dispatch('auth/setSktLoader', false, { root: true })
            })
        },

        guardarDatosNivelAfiliado({ commit, dispatch }, payload) {
            commit('setDatosNivelAfiliado', payload)
            dispatch('notificaciones/showSnack', {
                message: 'Datos guardados',
                type: "200"
            }, { root: true })
        },
        /* 
        POST -> http://10.1.1.19:8088/portal/opcionNivel/nuevaOpcionNivel
        {
            nroafi
            nuevoNivel
            esJubilado
            repiteEmpleo
            nevoNivelEMail
            empleo
            empleoTipo
            empleoDesde 
        }
        */

        async nuevaOpcionNivel({ commit, dispatch, rootGetters }, formData) {
            if (rootGetters['auth/esModoGestion']) {
                dispatch('notificaciones/showSnack', {
                    message: 'Operación no permitida en modo gestión.',
                    type: '400',
                }, { root: true });
                return false;
            }
            dispatch('notificaciones/startLoading', null, { root: true })
            await axios({
                method: 'post',
                url: process.env.VUE_APP_API + 'portal/opcionNivel/nuevaOpcionNivel',
                withCredentials: false,
                timeout: TIMEOUT_ENVIO_OPCION_NIVEL,
                headers: {
                    "Content-Type": "multipart/form-data",
                    "Authorization": "Bearer " + sessionStorage.getItem('token')
                },
                data: formData,
            }).then((response) => {
                console.log(response.data)
                dispatch('notificaciones/showSnack', {
                    message: response.data.msg,
                    type: "200",
                }, { root: true })
                //dispatch('getNivelAfiliado')
                //location.reload()
            }).catch(function (error) {
                dispatch('notificaciones/showSnack', {
                    message: mensajeErrorEnvioOpcionNivel(error),
                    type: "400",
                }, { root: true })
                console.log(error.toJSON())
            }).finally(() => {
                dispatch('getNivelAfiliado')
                //dispatch('notificaciones/stopLoading', null, { root: true })
            })
        },

        /* 
        POST -> /portal/opcionNivel/desestimarOpcionNivel   
        {
            nroafi
            nivelPedidoId
            nivelPedidoNro
            nivelPedidoEmail
        }
        */
        async desestimarOpcionNivel({ commit, dispatch, rootGetters }, data) {
            if (rootGetters['auth/esModoGestion']) {
                dispatch('notificaciones/showSnack', {
                    message: 'Operación no permitida en modo gestión.',
                    type: '400',
                }, { root: true });
                return false;
            }
            dispatch('notificaciones/startLoading', null, { root: true })
            await axios({
                method: 'post',
                url: process.env.VUE_APP_API + 'portal/opcionNivel/desestimarOpcionNivel',
                withCredentials: false,
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": "Bearer " + sessionStorage.getItem('token')
                },
                data: data,
            }).then((response) => {
                dispatch('notificaciones/showSnack', {
                    message: 'Desestimación enviada correctamente.',
                    type: "200"
                }, { root: true })
                console.log(response.data)
            }).catch(function (error) {
                dispatch('notificaciones/showSnack', {
                    message: 'Error: Desestimación no enviada.',
                    type: "400"
                }, { root: true })
                console.log(error.toJSON())
            }).finally(() => {
                //dispatch('notificaciones/stopLoading', null, { root: true })
                dispatch('getNivelAfiliado')
            })
        },
    }



})